<div class="close-job-dialog" *ngIf="viewModel$ | async as viewModel">
    <label>Reason (required)</label>
    <br>
    <p-dropdown
        appendTo="body"
        placeholder="Select Closure Reason"
        [options]="viewModel.closureReasons"
        optionLabel="title"
        optionValue="id"
        [autofocus]="true"
        [ngModel]="viewModel.closedReason"
        (ngModelChange)="store.dispatch(actions.closureReasonSelected({ closedReason: $event }))"
        >
    </p-dropdown>
        <div class="footer">
            <button
                pButton
                label="Exit Dialog"
                icon="pi pi-times"
                [outlined]="true" severity="secondary"
                (click)="ref.close(); store.dispatch(actions.exitDialogButtonClicked())"
            ></button>
            <button
                class="p-button-success"
                pButton
                label="Close Job"
                icon="pi pi-circle-fill"
                (click)="ref.close(); store.dispatch(actions.closeJobButtonClicked())"
                [disabled]="!viewModel.closedReason"
            ></button>
        </div>
</div>
